import React, { useState, useEffect } from 'react';
import { Paper, Grid, Avatar, Chip, Typography, InputAdornment, CircularProgress, TextField, IconButton, Card, CardContent, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate, useParams } from "react-router-dom";
import EmptyState from '../../components/Error/EmptyState';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from 'react-bootstrap';

const StationChecklistDetails = (props) => {
    const [addModal, setAddModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [generalModal, setGeneralModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const { id, scheduleId } = useParams();
    const [generalizedTicket, setGeneralizedTicket] = useState(null);
    const [disableItem, setDisableItem] = useState(false);
    const [itemName, setItemName] = useState('')
    const [ticketDetail, setTicketDetail] = useState('')
    const [title, setTitle] = useState('')
    const [details, setDetails] = useState('')
    const [openCategories, setOpenCategories] = useState({})
    const [locationDrop, setLocationDrop] = useState([])
    const [selectedStation, setSelectedStation] = useState("all")

    const getChecklistData = () => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId
        }
        ApiService.post('/checklist/data', body)
            .then((data) => {
                setTitle(data?.title)
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const getChecklistDetails = () => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId
        }
        ApiService.post('/checklist/station-inspection/schedule-results', body)
            .then((data) => {
                const items = data?.data?.checklist_station_items || [];
                setDetails(items)
                setGeneralizedTicket(data?.data?.generalizedTicket)
                // Default all categories to open
                const allOpen = items.reduce((acc, item) => {
                    acc[item.category || "No category"] = true;
                    return acc;
                }, {});
                setOpenCategories(allOpen)
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    useEffect(() => {
        getChecklistData()
        getChecklistDetails()
        getLocation()
    }, [])

    const getLocation = () => {
        ApiService.get('/checklist/location')
            .then(({ data }) => {
                const posArr = data?.data?.map((pos) => ({ label: pos.location_description, value: pos.id })) || [];
                setLocationDrop(posArr);
            })
            .catch(() => {});
    }

    const getLocationName = (id) => {
        if (!id) return "";
        const match = locationDrop.find(l => l.value == id);
        return match ? match.label : "";
    }

    const uniqueStations = [...new Set((details || []).map(i => i.location_id).filter(Boolean))];

    const filteredDetails = selectedStation === "all"
        ? details
        : (details || []).filter(i => i.location_id == selectedStation);

    const groupedDetails = filteredDetails && filteredDetails.length > 0 ? filteredDetails.reduce((acc, item) => {
        const key = item.category || "No category";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {}) : {};

    const toggleCategory = (category) => {
        setOpenCategories(prev => ({ ...prev, [category]: !prev[category] }));
    };

    let navigate = useNavigate();

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>)
                :
                (<>
                    <Paper className="p-4" style={{ marginTop: "1rem" }}>
                        <Grid container className='align-items-center' gap={2} fontFamily={'karla'}>

                            {/* Heading */}
                            <Grid item xs={10} md={9} sx={{ minWidth: '80% !important' }}>
                                <Typography variant="h5">
                                    <Link to={`/firehouse/station-checklist-schedule/${id}`} style={{ color: "black" }}>
                                        <ArrowBackIosIcon />
                                    </Link>
                                    {`Checklist > ${title}`}</Typography> 
                            </Grid>

                            {!details || details.length == 0 ?
                                <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 300, width: "100%" }}>
                                    <img src='/images/blur-logo.png' style={{ height: 150 }} />
                                    <span className='mt-4' style={{ color: '#555555' }}>
                                        No Details Found
                                    </span>
                                </div>
                                :
                                <Grid item className='align-items-center p-2' fontFamily={'karla'} md={12}>
                                    {uniqueStations.length > 0 && (
                                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16, overflowX: 'auto' }}>
                                            <div
                                                onClick={() => setSelectedStation("all")}
                                                style={{
                                                    cursor: 'pointer',
                                                    padding: '8px 16px',
                                                    borderRadius: '999px',
                                                    fontSize: 13,
                                                    fontFamily: 'karla, sans-serif',
                                                    userSelect: 'none',
                                                    whiteSpace: 'nowrap',
                                                    backgroundColor: selectedStation === "all" ? "#BF1D2D" : "#f0f0f0",
                                                    color: selectedStation === "all" ? "#fff" : "#555",
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                All
                                            </div>
                                            {uniqueStations.map(stationId => (
                                                <div
                                                    key={stationId}
                                                    onClick={() => setSelectedStation(stationId)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '8px 16px',
                                                        borderRadius: '999px',
                                                        fontSize: 13,
                                                        fontFamily: 'karla, sans-serif',
                                                        userSelect: 'none',
                                                        whiteSpace: 'nowrap',
                                                        backgroundColor: selectedStation == stationId ? "#BF1D2D" : "#f0f0f0",
                                                        color: selectedStation == stationId ? "#fff" : "#555",
                                                        transition: 'all 0.2s'
                                                    }}
                                                >
                                                    {getLocationName(stationId) || 'Unknown'}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    <div className='font-fam mt-2'>
                                        {Object.entries(groupedDetails).map(([category, items], index) => {
                                            const isOpen = openCategories[category];

                                            return (
                                                <div key={category} style={{ marginBottom: 16 }}>

                                                    {/* Category Header */}
                                                    <div
                                                        onClick={() => toggleCategory(category)}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            padding: '8px 4px',
                                                            borderBottom: '1px solid #e0e0e0',
                                                            userSelect: 'none'
                                                        }}
                                                    >
                                                        <span style={{
                                                            marginRight: 10,
                                                            fontSize: 10,
                                                            color: '#999',
                                                            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s ease',
                                                            display: 'inline-block'
                                                        }}>
                                                            ▶
                                                        </span>
                                                        <span style={{
                                                            minWidth: 22, height: 22, borderRadius: '50%',
                                                            background: '#BF1D2D', color: '#fff',
                                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                            fontSize: 11, fontWeight: 700, marginRight: 10, flexShrink: 0
                                                        }}>
                                                            {index + 1}
                                                        </span>
                                                        <span style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                                                            {category}
                                                        </span>
                                                        <span style={{
                                                            marginLeft: 8, fontSize: 12, color: '#aaa', fontWeight: 400
                                                        }}>
                                                            ({items.length} {items.length === 1 ? 'item' : 'items'})
                                                        </span>
                                                    </div>

                                                    {/* Child Items */}
                                                    <div
                                                        style={{
                                                            maxHeight: isOpen ? 1000 : 0,
                                                            overflow: 'hidden',
                                                            transition: 'max-height 0.3s ease'
                                                        }}
                                                    >
                                                        <div style={{
                                                            marginLeft: 16,
                                                            borderLeft: '2px solid #e0e0e0',
                                                            paddingLeft: 16,
                                                            marginTop: 8
                                                        }}>
                                                            {items.map((item, i) => (
                                                                <div
                                                                    key={item.id || i}
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 10,
                                                                        padding: '10px 0',
                                                                        borderBottom: i < items.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                        position: 'relative'
                                                                    }}
                                                                >
                                                                    {/* Horizontal connector line */}
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        left: -16,
                                                                        top: '50%',
                                                                        width: 12,
                                                                        height: 0,
                                                                        borderTop: '2px solid #e0e0e0'
                                                                    }} />
                                                                    <div style={{
                                                                        width: 6, height: 6, borderRadius: '50%',
                                                                        background: '#BF1D2D',
                                                                        flexShrink: 0
                                                                    }} />

                                                                    {/* Description + Parent Station */}
                                                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                                        <span style={{
                                                                            fontSize: 13, color: !item?.description ? '#ccc' : '#555',
                                                                            fontStyle: !item?.description ? 'italic' : 'normal',
                                                                            lineHeight: 1.5
                                                                        }}>
                                                                            {item?.description || "No description"}
                                                                        </span>
                                                                        {item?.location_id && (
                                                                            <span style={{ fontSize: 12, color: '#2B3F6C', fontWeight: 500 }}>
                                                                                Parent Station: <span style={{ fontWeight: 400, color: '#555' }}>{getLocationName(item?.location_id) || '—'}</span>
                                                                            </span>
                                                                        )}
                                                                    </div>

                                                                    {/* Status Chips */}
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                                                                        {item?.schedule_reports?.status == 'pass' ?
                                                                            <Chip
                                                                                variant="outlined"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: '#DDDDDD00',
                                                                                    color: '#2B3F6C',
                                                                                    border: '1px solid #2B3F6C80',
                                                                                }}
                                                                                avatar={<Avatar src="/images/check1.png" style={{ width: 24, height: 24, padding: 5 }} />}
                                                                                label={'Passed'}
                                                                            />
                                                                            :
                                                                            item?.schedule_reports?.status == 'failed' ?
                                                                                <>
                                                                                    <Chip
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        sx={{
                                                                                            backgroundColor: '#DDDDDD00',
                                                                                            color: '#BF1D2D',
                                                                                            border: '1px solid #BF1D2D',
                                                                                        }}
                                                                                        avatar={<Avatar src="/images/red-cross.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                                                                        label={'Failed'}
                                                                                    />

                                                                                    {item?.schedule_reports?.checklist_ticket_id != null &&
                                                                                        <Chip
                                                                                            variant="outlined"
                                                                                            size="small"
                                                                                            sx={{
                                                                                                backgroundColor: '#EAECF0',
                                                                                                color: '#2B3F6C',
                                                                                                border: '1px solid #2B3F6C',
                                                                                                cursor: 'pointer'
                                                                                            }}
                                                                                            avatar={<Avatar src="/images/eye.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                                                                            label={'View Ticket'}
                                                                                            onClick={() => {
                                                                                                setTicketDetail(item)
                                                                                                setShowModal(true)
                                                                                            }}
                                                                                        />
                                                                                    }
                                                                                </>
                                                                                :
                                                                                <Chip
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    sx={{
                                                                                        color: '#2B3F6C',
                                                                                        border: '1px solid #2B3F6C',
                                                                                    }}
                                                                                    avatar={<Avatar src="/images/eye.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                                                                    label={'Not Filled'}
                                                                                />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* View Generalize Ticket Button */}
                                    <Grid container gap={2} className='justify-content-end'>
                                        <Grid item xs={6} md={'auto'} className='btn-check-2'>
                                            <ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
                                                disabled={(!generalizedTicket || generalizedTicket == null)}
                                                onClick={() => {
                                                    setGeneralModal(true)
                                                    setDisableItem(true)
                                                    setItemName('')
                                                }}>
                                                View Generalize Ticket
                                            </ButtonTheme>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Paper >
                </>)}

            {/* View Ticket Pop-Up View */}
            <div className='font-fam'>
                <Modal className='checklist-modal' show={showModal} size="md" onHide={() => {
                    setShowModal(false)
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Ticket</Modal.Title>
                    </Modal.Header>
                    <div className='ticket-item-heading'>{ticketDetail?.schedule_reports?.ticket?.title}</div>
                    <Modal.Body >
                        <Grid item xs={12} sm={6} md={6}>
                            <div className='font-fam model-bg'>

                                <div >
                                    <div className='ticket-margin row'>
                                        <div className='ticket-item'>{
                                        ticketDetail?.location?.type == "location_item" ? "Location & Item : " 
                                            : ticketDetail?.location?.type == "location" ? "Location : " 
                                            : "Item : "} 
                                        {ticketDetail?.location?.location_description || ticketDetail?.item_location?.item?.item_description} </div>
                                        {/* <div className='ticket-item'>Item : {ticketDetail?.checklist_item_name} </div> */}
                                        <div className='ticket-todo'>{ticketDetail?.schedule_reports?.ticket?.tickteting_status?.status &&
                                            ticketDetail?.schedule_reports?.ticket?.tickteting_status?.status?.charAt(0)?.toUpperCase() + ticketDetail?.schedule_reports?.ticket?.tickteting_status?.status?.slice(1)?.toLowerCase()}</div>
                                    </div>

                                    <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{ticketDetail?.schedule_reports?.ticket?.assignee_employee_first_name ? (ticketDetail?.schedule_reports?.ticket?.assignee_employee_first_name + ' ' + ticketDetail?.schedule_reports?.ticket?.assignee_employee_last_name) : 'Unassigned'}</span> </div>
                                    </div>

                                    {/* <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{ticketDetail?.schedule_reports?.ticket?.notify_employee_first_name ? (ticketDetail?.schedule_reports?.ticket?.notify_employee_first_name + ' ' + ticketDetail?.schedule_reports?.ticket?.notify_employee_last_name) : 'Unassigned'}</span> </div>
                                    </div> */}

                                    <div className="col-md-7 mt-1">
                                        <Typography variant="h6">
                                            Description
                                        </Typography>
                                    </div>

                                    <div className='row'>
                                        <div className='col' style={{ color: !ticketDetail?.schedule_reports?.ticket?.description ? '#ccc' : 'inherit', pointerEvents: !ticketDetail?.schedule_reports?.ticket?.description ? 'none' : 'auto' }}>
                                            {ticketDetail?.schedule_reports?.ticket?.description || "--"}
                                        </div>
                                    </div>

                                    <div className='row mt-2'>
                                        <div className='col'>
                                            <Typography variant="h6">
                                                Image
                                            </Typography>
                                            {ticketDetail?.schedule_reports?.ticket?.image || ticketDetail?.schedule_reports?.ticket?.secondary_image ? (
                                                <>
                                                    {ticketDetail?.schedule_reports?.ticket?.image != null &&
                                                        <img src={ticketDetail?.schedule_reports?.ticket?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                    {ticketDetail?.schedule_reports?.ticket?.secondary_image != null &&
                                                        <img src={ticketDetail?.schedule_reports?.ticket?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                </>
                                            ) :
                                                <p>No Image Uploaded</p>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Modal.Body>
                </Modal>
            </div >

            {/* View Ticket Generalized Pop-Up View */}
            < div className='font-fam' >
                <Modal className='checklist-modal' show={generalModal} size="md" onHide={() => {
                    setGeneralModal(false)
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Generalized Ticket</Modal.Title>
                    </Modal.Header>
                    <div className='ticket-item-heading'>{generalizedTicket?.title}</div>
                    <Modal.Body >
                        <Grid item xs={12} sm={6} md={6}>
                            <div className='font-fam model-bg'>

                                <div >
                                    <div className='ticket-margin row'>
                                        <div className='ticket-item'>Generalized Ticket</div>
                                        <div className='ticket-todo'>{generalizedTicket?.tickteting_status?.status &&
                                            generalizedTicket.tickteting_status.status.charAt(0).toUpperCase() +
                                            generalizedTicket.tickteting_status.status.slice(1)}</div>
                                    </div>

                                    <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{generalizedTicket?.employee_first_name ? (generalizedTicket?.employee_first_name + ' ' + generalizedTicket?.employee_last_name) : 'Unassigned'}</span> </div>
                                    </div>

                                    {/* <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{generalizedTicket?.notify_employee_first_name ? (generalizedTicket?.notify_employee_first_name + ' ' + generalizedTicket?.notify_employee_last_name) : 'Unassigned'}</span> </div>
                                    </div> */}

                                    <div className="col-md-7 mt-1">
                                        <Typography variant="h6">
                                            Description
                                        </Typography>
                                    </div>

                                    <div className='row'>
                                        <div className='col' style={{ color: !generalizedTicket?.description ? '#ccc' : 'inherit', pointerEvents: !generalizedTicket?.description ? 'none' : 'auto' }}>
                                            {generalizedTicket?.description || "--"}
                                        </div>
                                    </div>

                                    <div className='row mt-2'>
                                        <div className='col'>
                                            <Typography variant="h6">
                                                Image
                                            </Typography>
                                            {generalizedTicket?.image || generalizedTicket?.secondary_image ? (
                                                <>
                                                    {generalizedTicket?.image != null &&
                                                        <img src={generalizedTicket?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                    {generalizedTicket?.secondary_image != null &&
                                                        <img src={generalizedTicket?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                </>
                                            ) :
                                                <p>No Image Uploaded</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Grid>
                    </Modal.Body>
                </Modal>
            </div >
        </>
    )
}
export default StationChecklistDetails;